import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

export type RemoveDataRoomModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  dataRoomName: string;
  isUpdatePending?: boolean;
};

export const RemoveDataRoomModal = ({
  onClose,
  onConfirm,
  dataRoomName,
  isUpdatePending,
}: RemoveDataRoomModalProps) => (
  <ActionaryModal
    ModalButtonsGroupProps={{
      mainActionText: m.btn_confirm(),
      mainAction: onConfirm,
      mainActionVariant: "destructive",
      disabled: isUpdatePending,
      secondaryActionText: m.common_cancel(),
      secondaryAction: onClose,
      disabledSecondary: isUpdatePending,
    }}
    fluidHeight
    open
    setOpen={onClose}
    title={m.coInvestments_dataRoom_removeModal_title()}
  >
    <p className="body-base-regular text-text/secondary mt-4">
      {m.coInvestments_dataRoom_removeModal_description({ dataRoomName })}
    </p>
  </ActionaryModal>
);
